import {
  shouldCreateColumn,
  isColumn,
  isField,
  isRow,
  movedToBuildArea,
  updateList,
  createColumn,
  addToColumn,
  isUIblockList,
  moveToList,
  shouldCreateRowWithColumn,
  returnUiBlock,
  getElement,
  get2Delement,
  deepCopy,
  getRowId,
  getIDs
} from "./onDragUtils";

const addNewRow = (result, uiBlocks, buildArea, insertIndex) => {
  const [movedField] = uiBlocks.splice(result.source.index, 1);

  const newRow = {
    type: "row",
    data: [
      {
        type: "column",
        data: [{ type: "field", ...movedField }],
      },
    ],
  };

  const newBuildArea = [...buildArea];
  newBuildArea.splice(insertIndex, 0, newRow); // vloží nový riadok na zadaný index

  return {
    newBuildArea,
    newUiBlocks: uiBlocks,
  };
};

const moveWithinArea = (result, buildArea, uiBlocks, sourceId) => {
  // Pohyb v liste vytvoreneho z komponentov detailSchemy (uiBlocks-list)
  if (sourceId === "uiBlocks-list") {
    updateList(uiBlocks, result, false);
  }
  // Pohyb bloku (field) v rovnakom stlpci
  else if (isField(sourceId)) {
    const column = get2Delement(sourceId, buildArea);
    updateList(column, result, false);
  }
  // Pohyb stlpcov v rovnakom riadku
  else if (isColumn(sourceId)) {
    const row = getElement(sourceId, buildArea);
    updateList(row, result);
  }
  // Pohyb riadkov v buildArea
  else if (isRow(sourceId)) {
    updateList(buildArea, result, false);
  }
  return { newBuildArea: buildArea, newUiBlocks: uiBlocks };
}

const removeElementAndMove = (result, buildArea, destinationId, array) => {
  const [element] = array.splice(result.source.index, 1);
  const bool_result = destinationId.split("-")[2] === "0";
  return shouldCreateColumn(destinationId) ?
    createColumn(element, buildArea, destinationId, bool_result) :
    addToColumn(element, buildArea, destinationId, result);
}

const moveToBuildArea = (result, buildArea, uiBlocks, destinationId) => {
  const blocks = uiBlocks;
  return removeElementAndMove(result, buildArea, destinationId, blocks);
}

const moveField = (result, buildArea, sourceId, destinationId) => {
  const column = get2Delement(sourceId, buildArea);
  return removeElementAndMove(result, buildArea, destinationId, column);
}

const moveColumn = (result, buildArea, sourceId, destinationId) => {
  const sourceRow = getElement(sourceId, buildArea);
  const destinationRow = getElement(destinationId, buildArea);
  buildArea[getRowId(destinationId)] = moveToList(sourceRow, destinationRow, result);
  return buildArea;
}

const addRow = (result, buildArea, isColumn, sourceId, insertIndex) => {
  const block = isColumn
    ? getElement(sourceId, buildArea)
    : get2Delement(sourceId, buildArea);

  const [deletedBlock] = isColumn
    ? block.data.splice(result.source.index, 1)
    : block.splice(result.source.index, 1);

  const row = isColumn
    ? { type: "row", data: [deletedBlock] }
    : { type: "row", data: [{ type: "column", data: [deletedBlock] }] };

  const newBuildArea = [...buildArea];
  newBuildArea.splice(insertIndex, 0, row);

  return newBuildArea;
};


const editBuildArea = (result, buildArea, uiBlocks) => {
  const sourceId = result.source.droppableId;
  const destinationId = result.destination.droppableId;
  const index = destinationId.split("-")[1];
  let newBuildArea = [];
  // Presunutie z uiBlocks zoznamu
  if (isUIblockList(sourceId)) {
    newBuildArea = moveToBuildArea(result, buildArea, uiBlocks, destinationId);
  }
  // Pohyb stlpca medzi existujucimi riadkami v buildArea
  else if (isColumn(sourceId) && isColumn(destinationId)) {
    newBuildArea = moveColumn(result, buildArea, sourceId, destinationId);
  }
  // Vytvorenie noveho riadka presunutim stlpca do prazdneho priestoru v buildArea
  else if (isColumn(sourceId) && shouldCreateRowWithColumn(destinationId)) {
    newBuildArea = addRow(result, buildArea, true, sourceId, index);
  }
  // Vytvorenie noveho riadka presunutim bloku (field) do prazdneho priestoru v buildArea
  else if (isField(sourceId) && destinationId.split("-")[0] === "addRow") {
    newBuildArea = addRow(result, buildArea, false, sourceId, index);
  }
  // Presun bloku (field) do vnutra buildArea
  else if (isField(sourceId)) {
    newBuildArea = moveField(result, buildArea, sourceId, destinationId);
  }

  return { newBuildArea: newBuildArea, newUiBlocks: uiBlocks };
}

export const onDragEnd = (result, buildArea, uiBlocks) => {
  // Bloky mozu byt posuvane len do droppable area
  if (!result.destination) return { undefined };

  const buildAreaCopy = deepCopy(buildArea);
  const sourceId = result.source.droppableId;
  const destinationId = result.destination.droppableId;
  const index = destinationId.split("-")[1];

  // vytvorenie noveho riadku z uiBloku
  if (sourceId === "uiBlocks-list" && destinationId.split("-")[0] === "addRow") {
    return addNewRow(result, uiBlocks, buildAreaCopy, index);
  }
  // Pohyb v rovnakej droppable area
  if (sourceId === destinationId) {
    return moveWithinArea(result, buildAreaCopy, uiBlocks, sourceId);
  }
  if (movedToBuildArea(destinationId)) {
    return editBuildArea(result, buildAreaCopy, uiBlocks);
  }
  // Vratenie bloku (field) z build area do uiBlocks-listu
  const elementPosition = getIDs(sourceId);
  const element = buildArea[elementPosition.rowId].data[elementPosition.colId].data[result.source.index];

  if (sourceId !== "uiBlocks-list" && destinationId === "uiBlocks-list" && element.ui_type === "db_field") {
    return returnUiBlock(result, buildAreaCopy, uiBlocks, sourceId);
  }

  return { undefined };
};